import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { get, post } from "../../services/api";

function NotesStudentModal({ onClose, studentId, onSave }) {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      notes: "",
    },
  });

  // Fetch notes for the student when the modal opens
  useEffect(() => {
    const fetchNotes = async () => {
      if (!studentId || !token) {
        toast.error("Missing student ID or authentication token.");
        return;
      }

      setLoading(true);
      try {
        const response = await get(
          `Student/GetAttendanceNotesByStudentId?studentId=${studentId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response) {
          setValue("notes", response.attnNotes);
        } else {
          setValue("notes", ""); // Set empty notes if none found
          toast.error("Please Saved Attendance First For this Student");
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
        toast.error("Failed to fetch notes.");
      } finally {
        setLoading(false);
      }
    };

    fetchNotes();
  }, [studentId, token, setValue]);

  // Handle form submission to save notes
  const onSubmit = async (data) => {
    if (!studentId || !token) {
      toast.error("Missing student ID or authentication token.");
      return;
    }

    try {
      const response = await post(
        `Student/SaveAttendanceNotes?StudentId=${studentId}&Notes=${data.notes || ""}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.isSuccess) {
        toast.success(response.message || "Notes saved successfully!");
        if (onSave) onSave(data.notes);
        onClose(); // Close the modal on success
      } else {
        toast.error(response.message);
        onClose(); // Close the modal on success
      }
    } catch (error) {
      console.error("Error saving notes:", error);
      toast.error("Failed to save notes.");
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Notes for Student</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                disabled={isSubmitting}
              ></button>
            </div>
            <div className="modal-body">
              <form
                className="new-form-style"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="row g-3 new-form-style">
                      <div>
                        <label className="form-label form-label-new">
                          Notes
                        </label>
                        <Controller
                          name="notes"
                          control={control}
                          rules={{
                            // required: "This field is required.",
                            maxLength: {
                              value: 1000,
                              message: "Notes cannot exceed 1000 characters.",
                            },
                          }}
                          render={({ field }) => (
                            <textarea
                              {...field}
                              className={`form-control ${
                                errors.notes ? "is-invalid" : ""
                              }`}
                              rows="5"
                              placeholder="Enter notes here..."
                              disabled={loading || isSubmitting}
                            />
                          )}
                        />
                        {errors.notes && (
                          <small className="text-danger">
                            {errors.notes.message}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-3 d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={onClose}
                    disabled={isSubmitting}
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm"
                    disabled={loading || isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default NotesStudentModal;
